import React from 'react';
import { Card, Row, Col, Divider, Button } from 'antd';
import { ProjectOutlined } from '@ant-design/icons';

const ProjectOverview = ({ projects }) => {
  return (
    <Card title="项目概览">
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <div className="text-center p-4 bg-blue-50 rounded">
            <div className="text-2xl font-bold text-blue-600">{projects.owned}</div>
            <div className="text-gray-600">负责项目</div>
          </div>
        </Col>
        <Col span={12}>
          <div className="text-center p-4 bg-green-50 rounded">
            <div className="text-2xl font-bold text-green-600">{projects.participated}</div>
            <div className="text-gray-600">参与项目</div>
          </div>
        </Col>
      </Row>
      <Divider />
      <div className="text-center">
        <Button type="primary" block icon={<ProjectOutlined />}>
          查看所有项目
        </Button>
      </div>
    </Card>
  );
};

export default ProjectOverview;